import React from "react";
import { Tooltip } from "@mantine/core";

import { Policy } from "@pages/policy/types";

const DEFAULT_POLICY_NAME = "(default)";

export const PolicyCell: React.FC<{
  selectedPolicies: Policy[];
}> = ({ selectedPolicies }) => {
  return (
    <>
      {selectedPolicies.length === 0 ? (
        <span>(default)</span>
      ) : (
        <>
          {selectedPolicies[0].name}
          {selectedPolicies.length > 1 && (
            <Tooltip
              withinPortal
              withArrow
              label={
                <>
                  {selectedPolicies.slice(1).map((p, idx) => (
                    <div key={idx}>{p?.name ?? DEFAULT_POLICY_NAME}</div>
                  ))}
                </>
              }
              position="bottom"
            >
              <div>
                {`, +${selectedPolicies.length - 1} ${
                  selectedPolicies.length === 2 ? "other" : "others"
                }`}
              </div>
            </Tooltip>
          )}
        </>
      )}
    </>
  );
};
